import { apiGateway } from '../api'

async function inserirCentroCusto(body) {
    try {
        body.validationResult = {};
        body.indicadorExclusao = "";
        body.acaoTransacao = "I";

        const response = await apiGateway.post('/centroscusto', body);

        return response.data;
    } catch (error) {
        return error.response.data[0] || false;
    }
}

async function alterarCentroCusto(codigoTsCentroCusto, body) {
    try {
        body.validationResult = {};
        body.acaoTransacao = "A";

        const response = await apiGateway.put(`/centroscusto/${codigoTsCentroCusto}`, body);

        return response.data;
    } catch (error) {
        return error.response.data[0] || false;
    }
}

async function excluirCentroCusto(codigoTsCentroCusto) {
    try {
        const response = await apiGateway.delete(`/centroscusto/${codigoTsCentroCusto}`);

        return response.data;
    } catch (error) {
        return false;
    }
}

async function buscarCentroCusto(numContrato, codCentroCusto = null) {
    try {
        const params = new URLSearchParams();
        params.append("numContrato", numContrato);

        if (codCentroCusto) {
            params.append("codCentroCusto", codCentroCusto);
        }

        const response = await apiGateway.get("/centroscusto", { params });

        return response.data;
    } catch (error) {
        return false;
    }
}


export { inserirCentroCusto, alterarCentroCusto, excluirCentroCusto, buscarCentroCusto };